<div class="topDiv" [style.background-color]="backgroundColorScreen">

    <div class="agGridOuterDiv">
        <div>
          <mat-toolbar class="agGridtoperDiv card" style="
                  background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;
          border-left: 1px solid #a9a9a9a8;">
  
                      <label i18n="@@spmsUserReg" class="textColour">Snapshot Details</label>
                      
                      <span class="example-spacer"></span>
                      <!-- <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="buttonColor" title="Configure Pivot" (click) = "openPivotConfigurationPopup()">Configure Visuals
                      </button> -->
<!-- Hidden file input -->
<input 
  type="file" 
  id="excelFileInput" 
  accept=".xlsx, .xls"
  style="display: none;"
  (change)="onFileSelected($event)"
/>
<!-- <button class="popup gridColour btn btn-rounded-button z-depth-1
        waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" [style.min-width.px]="100"
  style="font-size: 12px; padding: 4px 10px; height: 32px;" id="102" title="Import Data" (click)="importData()">
  Import
  <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;" title="Import Data"></em>
</button> -->
<app-common-button  label="Import Data" title="Import Data" icon="fas fa-download"  style="margin-left: 6px;margin-right:6px;"
             [buttonId]="102" [critical]="true" width="95px"(clicked)="importData()">
          </app-common-button>

<!-- Upload Button -->
<!-- <button  
  class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
  [style.background-color]="backgroundColorButton"
  title="Upload Snapshot File"
  (click)="triggerFileInput()" id="108"
>
  Upload File
  <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload" title="Upload File"></em>
</button> -->
        <app-common-button  label="Upload File" title="Upload File" icon="fas fa-upload"
             [buttonId]="108" [critical]="true" width="100px"(clicked)="triggerFileInput()">
          </app-common-button>

                      <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Create Snapshot"  id="114" (click)="openSaveForm()">Create Snapshot
                      </button>
                      <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">Download
                        <em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                </button>
                  <div class="insertPageNoDiv">
                      <mat-form-field appearance="outline">
                          <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
                          <input matInput type="text" (input)="onSearchChange($event.target.value)">
                      </mat-form-field>
                  </div>
  
                  <div class="selectRecordsDiv" style="width:9.5%">
                      <mat-form-field appearance="outline" style="width:100%">
                          <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
                          <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                              <mat-option value="10" selected>10</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="300">300</mat-option>
                              <mat-option value="400">400</mat-option>
                          </mat-select>
  
                      </mat-form-field>
                  </div>
                  <div class="card pagination paginationFirstButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                  </div>
                  <div class="card pagination paginationButtons btn-rounded">
                      <ul>
                          <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                  (click)="onBtPrevious()"></em></li>
                                  <li>{{currentPage}}/{{totalPages}}</li>
                          <li class="paginationliicon" style="padding:0;"><em
                                  class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
                      </ul>
                  </div>
                  <div class="card pagination paginationLastButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                  </div>
                </mat-toolbar>
              </div>
        <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs"  [animateRows]="true"
        [pagination]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35"
        [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
        (paginationChanged)="onPaginationChanged()" [components]="components"
        (gridReady)="onGridReady($event)" [hidden]="!true">
    </ag-grid-angular>
    </div>
    </div>
  